module.exports = __webpack_public_path__ + "static/PipeDrive-981391afa8a2051436637febf67f6628.webp";